/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { RouteCodes } from '@core/config/route-codes';
import { POSITION_ROUTES_TREE } from '@core/config/routes-tree';
import { StepCodes } from '@core/config/step-codes';
import { STEPS_CONFIG as CORE_STEPS_CONFIG } from '@core/config/steps-config';
import { StepConfigModel } from '@models/wizard/steps-config.model';

export const STEPS_CONFIG: {
  [stepCode: string]: StepConfigModel;
} = {
  ['CONS-SPER']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['MOBILE-START']: {
    path: POSITION_ROUTES_TREE[RouteCodes.atcChoice].path
  },
  ['MTR-CLI']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['CONS-PRIVACY']: { ...CORE_STEPS_CONFIG[StepCodes.consents] },
  ['CERT-CONT']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['RICO-CLI']: { ...CORE_STEPS_CONFIG[StepCodes.recognition] },
  ['UPL-DOC']: { ...CORE_STEPS_CONFIG[StepCodes.documentsRequest] },
  ['SOSP-DAT-STIP']: { ...CORE_STEPS_CONFIG[StepCodes.waitingLong] },
  ['CONF-SIM']: { ...CORE_STEPS_CONFIG[StepCodes.quotation] },
  ['WEB-DATI-ECO']: {
    path: POSITION_ROUTES_TREE[RouteCodes.dataCollection].path
  },
  ['WEB-QUEST']: { ...CORE_STEPS_CONFIG[StepCodes.adequacy] },
  ['SOSP-CONS-CLI']: { ...CORE_STEPS_CONFIG[StepCodes.waitingShort] },
  ['WEB-STAMP-CONTR']: { ...CORE_STEPS_CONFIG[StepCodes.contractSigning] },
  ['WEB-STAMP-CONTR-TFR']: {
    ...CORE_STEPS_CONFIG[StepCodes.contractSigning],
    params: { skipStatusCheck: true, startedByVertical: true, avoidExit: true }
  },
  ['WEB-SIM']: { ...CORE_STEPS_CONFIG[StepCodes.quotationCalculation] },
  ['WEB-GEST-IMP']: { ...CORE_STEPS_CONFIG[StepCodes.obligations] },
  ['PV-TFR-REL']: { ...CORE_STEPS_CONFIG[StepCodes.tfrRelease] },
  ['PV-WITHDRAW']: {
    ...CORE_STEPS_CONFIG[StepCodes.withdraw],
    params: { reason: 'REV-FIDO-WEBAPP' }
  }
};
